import { createFileRoute } from "@tanstack/react-router";
import { AuthForm } from "@/knowmeno/AuthGate";

export const Route = createFileRoute("/sign-in")({
  head: () => ({
    meta: [
      { title: "Sign in — KnowMeno" },
      { name: "description", content: "Sign in to your KnowMeno account to continue tracking your symptoms, cycle, HRT, and Menopause Score." },
      { property: "og:title", content: "Sign in — KnowMeno" },
      { property: "og:description", content: "Sign in to your KnowMeno account to continue tracking your symptoms, cycle, HRT, and Menopause Score." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://knowmeno.com/sign-in" },
    ],
    links: [{ rel: "canonical", href: "https://knowmeno.com/sign-in" }],
  }),
  component: SignInPage,
});

function SignInPage() {
  return <AuthForm mode="signin" />;
}
